import PropTypes from "prop-types";
import React from "react";

import { getColorVariable } from "../getColorVariable";
import { Transition, transitionPropTypes } from "../Transition";

/**
 * AnimateSvgElement renders the child element of SVG element. E.G. a circle or path.
 *
 * Props can be given to alter the SVG element such as setting the stroke when it's originally
 * rendered, via initial props, or the element can animate changes such as changing stroke width.
 */
export const AnimateSvgElement = (props) => {
  const { animate, className, element, initial, style, transition } = props;

  return <Transition {...getProps()} />;

  function getProps() {
    return {
      animate,
      className,
      component: element,
      initial: {
        ...initial,
        ...(initial?.fill && { fill: getColorVariable(initial.fill) }),
        ...(initial?.stroke && { stroke: getColorVariable(initial.stroke) }),
      },
      style,
      transition,
    };
  }
};

AnimateSvgElement.displayName = "AnimateSvgElement";

AnimateSvgElement.propTypes = {
  /** Values to transition. See Transition component for more information. */
  animate: transitionPropTypes.animate,

  /** aria-label text to provide additional accessibility description for the button element. */
  "aria-label": PropTypes.string,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Name of SVG element to be rendered in the SVG container. Element would be like "path" or "circle". */
  element: PropTypes.string,

  /** Values to set on element initially. See Transition component for more information. */
  initial: transitionPropTypes.initial,

  /** This object provides a way to add CSS values in addition to the properties that will be transformed. */
  style: PropTypes.object,

  /** Values to transition. See Transition component for more information. */
  transition: transitionPropTypes.transition,
};
